import { Export } from 'domain-entities';
import { isCancelable } from '@shared/firebase/export/export.functions';

export function cancelExport(oldExport: Export): Partial<Export> {
	if (!isCancelable(oldExport)) {
		return undefined;
	}
	return { state: 'canceled' };
}
